export const PICKER_DROPDOWN_RESULTS_MAX_PX = 192;
export const PICKER_DROPDOWN_CREATE_LINE_PX = 56;
export const PICKER_DROPDOWN_MARGIN_PX = 8;
export const PICKER_DROPDOWN_SAFE_GAP_PX = 16;

export const estimatePickerDropdownHeight = (hasCreateLine: boolean): number =>
    PICKER_DROPDOWN_MARGIN_PX
    + PICKER_DROPDOWN_RESULTS_MAX_PX
    + (hasCreateLine ? PICKER_DROPDOWN_CREATE_LINE_PX : 0)
    + PICKER_DROPDOWN_SAFE_GAP_PX;

export const resolvePickerClipBounds = (
    viewportHeight: number,
    parentRect?: { top: number; bottom: number }
): { top: number; bottom: number } => ({
    top: parentRect ? Math.max(0, parentRect.top) : 0,
    bottom: parentRect ? Math.min(viewportHeight, parentRect.bottom) : viewportHeight
});

export const shouldOpenPickerDropdownUpwards = (
    pickerTop: number,
    pickerBottom: number,
    clip: { top: number; bottom: number },
    dropdownHeight: number
): boolean => {
    const spaceBelow = clip.bottom - pickerBottom;
    const spaceAbove = pickerTop - clip.top;
    return spaceBelow < dropdownHeight && spaceAbove > spaceBelow;
};
